"use strict";

var _extends = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];

    for (var o in r) {
      Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
  }

  return e;
};

function _objectWithoutProperties(e, t) {
  var r = {};

  for (var o in e) {
    0 <= t.indexOf(o) || Object.prototype.hasOwnProperty.call(e, o) && (r[o] = e[o]);
  }

  return r;
}

var React = require("react"),
    PropTypes = require("prop-types"),
    classnames = require("classnames"),
    BasicButton = React.forwardRef(function (e, t) {
  var r = e.icon,
      o = e.className,
      n = e.leftIcon,
      s = e.text,
      a = e.rightIcon,
      c = _objectWithoutProperties(e, ["icon", "className", "leftIcon", "text", "rightIcon"]),
      l = classnames("blx-button", o, {
    "blx-icon-button": !!r,
    "blx-disabled": c.disabled
  });

  return React.createElement("button", _extends({
    className: l,
    ref: t
  }, c), n, s && React.createElement("span", null, s), r, a);
});

BasicButton.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
  icon: PropTypes.node,
  disabled: PropTypes.bool
}, BasicButton.defaultProps = {
  className: "blx-primary",
  text: "",
  leftIcon: null,
  rightIcon: null,
  icon: null,
  disabled: !1
}, module.exports = BasicButton;